import { useRef, useState } from 'react'

function useProgressiveCount(
  initialValue?: number
): [number | undefined | null, (newValue: number) => void] {
  const [value, setValue] = useState<number | undefined | null>(
    initialValue ? initialValue : 0
  )
  const interval = useRef<any>(null)
  const stopCondition = useRef<any>(null)
  const valueRef = useRef<any>(null)
  valueRef.current = value

  const changeNumber = (newValue: number): any => {
    interval.current && clearInterval(interval.current)
    stopCondition.current = newValue

    const distancia = Math.floor(Math.abs(valueRef.current - newValue))
    const tempo = 300 / distancia

    interval.current = setInterval(() => {
      const d = valueRef.current - stopCondition.current
      if (d === 0) {
        clearInterval(interval.current)
      } else if (d > 1) {
        setValue(valueRef.current - 1)
      } else if (d < -1) {
        setValue(valueRef.current + 1)
      } else {
        setValue(stopCondition.current)
      }
    }, tempo)
  }

  return [value, changeNumber]
}

export default useProgressiveCount
